'use strict';

class PhoneListSection {
	constructor(props = {}) {
		console.log('PhoneListSection::constructor(%o)', props);

		const section = document.getElementById('phone_list_holder');
		this.swiperContainer = section.querySelector('.swiper-container');
		this.swiperPagination = section.querySelector('.swiper-pagination');
		this.swiperButtonNext = section.querySelector('.swiper-button-next');
		this.swiperButtonPrev = section.querySelector('.swiper-button-prev');

		Object.assign(this, props);

		this.pageEvents();
	}

	pageEvents() {
		const that = this;

		new Swiper(that.swiperContainer, {
			pagination: that.swiperPagination,
			nextButton: that.swiperButtonNext,
			prevButton: that.swiperButtonPrev,
			slidesPerView: 3,
			spaceBetween: 20,
			grabCursor: true,
			breakpoints: {
				1200: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 1
				}
			}
		});
	}
}

window.addEventListener('DOMContentLoaded', () => {
	try {
		new PhoneListSection({});
	} catch (e) {
		console.error(e);
	}
});
